import { render, staticRenderFns } from "./AboutSccountScore.vue?vue&type=template&id=e0c3411a"
import script from "./AboutSccountScore.vue?vue&type=script&lang=js"
export * from "./AboutSccountScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports